import { createSessionInputDraftApplication } from '@/ikkodate/composition/createSessionInputDraftApplication'
import { STORAGE_KEYS } from '@/2D3DEditer/storage/storageKeys'

export function getFloorplanInputDraftKey(idempotencyKey) {
  return STORAGE_KEYS.inputDraft(idempotencyKey)
}

export function loadFloorplanInputDraft(idempotencyKey) {
  return createSessionInputDraftApplication().loadInputDraft(idempotencyKey)
}

export function saveFloorplanInputDraft(idempotencyKey, draft) {
  return createSessionInputDraftApplication().saveInputDraft(idempotencyKey, draft)
}

export function clearFloorplanInputDraft(idempotencyKey) {
  return createSessionInputDraftApplication().clearInputDraft(idempotencyKey)
}